import { configFetch as fetch } from '@meiqia/utils';

export const getAgentGroupsApi = () => {
  return fetch({
    url: `/agent/agent_groups`
  });
};
